import { createClient, type SupabaseClient } from '@supabase/supabase-js';

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (client) {
    return client;
  }

  const url = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string | undefined;
  const anonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string | undefined;

  if (!url || !anonKey) {
    return null;
  }

  client = createClient(url, anonKey);
  return client;
}

export default getSupabase;